import { queryOptions, useQuery } from '@tanstack/react-query';
import { ItemsApi } from '@/common/api/items';
import { commonQueryKeys } from '@/common/queryKeys/common';

export const getItemFetchQueryOptions = ({
  itemId,
  enabled = true,
  retry = false,
}: {
  itemId: number;
  enabled?: boolean;
  retry?: boolean;
}) =>
  queryOptions({
    queryKey: commonQueryKeys.item(itemId),
    queryFn: () => ItemsApi.getItemById({ itemId }),
    enabled,
    retry,
  });

export const useItemFetchQuery = ({
  itemId,
  enabled,
  retry = false,
}: {
  itemId: number;
  enabled?: boolean;
  retry?: boolean;
}) => {
  return useQuery(getItemFetchQueryOptions({ itemId, enabled, retry }));
};
